var path = '/formViewer/structure/row/rowPlaceholder.tpl.html';
var html = "<ui-row row=\"row\"></ui-row>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;